import PropTypes from 'prop-types';
import {
	ACTIVE_PLAN,
	NO_ACTIVE_PLAN,
	ACTIVE_SUBSCRIPTION,
	FAILED_SUBSCRIPTION,
	PAST_DUE_SUBSCRIPTION
} from './CurrentPaymentPlanStatus';

const ActivePlan = PropTypes.shape({
	status: PropTypes.oneOf([ACTIVE_PLAN]).isRequired,
	expirationDate: PropTypes.string,
	products: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string.isRequired,
			iconUrl: PropTypes.string.isRequired
		})
	).isRequired
});

const InactivePlan = PropTypes.shape({
	status: PropTypes.oneOf([NO_ACTIVE_PLAN]).isRequired,
	expirationDate: PropTypes.string.isRequired
});

const PlanWithRenewalDate = PropTypes.shape({
	status: PropTypes.oneOf([ACTIVE_SUBSCRIPTION]).isRequired,
	renewalDate: PropTypes.string.isRequired,
	price: PropTypes.string.isRequired
});

const FailedPlan = PropTypes.shape({
	status: PropTypes.oneOf([PAST_DUE_SUBSCRIPTION, FAILED_SUBSCRIPTION]).isRequired
});

const NullPlan = PropTypes.shape({
	status: PropTypes.oneOf([null])
});

export default PropTypes.oneOfType([
	ActivePlan,
	InactivePlan,
	PlanWithRenewalDate,
	FailedPlan,
	NullPlan
]);
